import React, { useEffect } from 'react';
import { isRaid2026LpPublished } from '../config/raid2026';
import RaidLanding from '../components/raid2026/RaidLanding';
import { useMetadata } from '../hooks/useMetadata';
import useGoogleTagManager from '../hooks/useGoogleTagManager';
import { ENVIRONMENT } from '../config/environment';
import raidMeta from '../components/raid2026/raidMeta.json';

export default function Raid2026() {
  const { setMetadata } = useMetadata();
  const published = isRaid2026LpPublished();

  useGoogleTagManager(published && ENVIRONMENT.IS_PRODUCTION);

  // RAID LP 用のメタ/OGP をクライアント側でも設定する。
  // SNS クローラ向けの静的 HTML は build 時に生成しているが、
  // ブラウザのタブ名や JS 実行系クローラ、SPA 内遷移ではこちらが効く。
  useEffect(() => {
    if (!published) {
      return;
    }

    const pageUrl = `${ENVIRONMENT.SITE_URL}${raidMeta.path}`;
    const imageUrl = `${ENVIRONMENT.SITE_URL}${raidMeta.ogImagePath}`;

    setMetadata({
      title: raidMeta.title,
      description: raidMeta.description,
      ogTitle: raidMeta.title,
      ogDescription: raidMeta.description,
      ogImage: imageUrl,
      ogUrl: pageUrl,
      canonicalUrl: pageUrl,
      twitterCard: 'summary_large_image',
      twitterTitle: raidMeta.title,
      twitterDescription: raidMeta.description,
    });
  }, [published, setMetadata]);

  if (!published) {
    return (
      <div className="min-h-screen bg-background flex flex-col items-center justify-center px-6 py-12 font-body text-center">
        <p className="text-base text-muted-foreground">
          このページは公開準備中です。
        </p>
      </div>
    );
  }

  return <RaidLanding />;
}
